import { render } from "./LandingPageMoreDropdown.vue?vue&type=template&id=a53b2a98&scoped=true"
import script from "./LandingPageMoreDropdown.vue?vue&type=script&lang=js"
export * from "./LandingPageMoreDropdown.vue?vue&type=script&lang=js"

import "./LandingPageMoreDropdown.vue?vue&type=style&index=0&id=a53b2a98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a53b2a98"]])

export default __exports__